export enum GoodsTypeEnum {
  GOODS_UNKNOWN = "GOODS_UNKNOWN",
  GOODS_POST = "GOODS_POST",
  GOODS_ACTIVATION = "GOODS_ACTIVATION",
  GOODS_WHITELIST = "GOODS_WHITELIST",
}

export enum SubGoodsTypeEnum {
  WHITELIST_CONTRACT = "WHITELIST_CONTRACT",
  WHITELIST_GROUP = "WHITELIST_GROUP",
  VIP_MONTH = "VIP_MONTH",
  VIP_SEASON = "VIP_SEASON",
  CUSTOMIZE_PHONE_CASE = "CUSTOMIZE_PHONE_CASE",
  CUSTOMIZE_PICTURE = "CUSTOMIZE_PICTURE",
  SPRING_GIFT_BAG = "SPRING_GIFT_BAG",
  CUSTOMIZE_NO_CODE = "CUSTOMIZE_NO_CODE",
}

export const Step = {
  item: 1,
  order: 2,
};

export const LimitReasonEnum = {
  LIMIT_REASON_UNKNOWN: "LIMIT_REASON_UNKNOWN",
  LIMIT_REASON_REDEEMED: "LIMIT_REASON_REDEEMED", // 总时间的库存限制
  LIMIT_REASON_REDEEMED_NATURAL_MONTH: "LIMIT_REASON_REDEEMED_NATURAL_MONTH", // 本月内的库存限制
  LIMIT_REASON_REDEEMED_NATURAL_DAY: "LIMIT_REASON_REDEEMED_NATURAL_DAY", // 本日内的库存限制
};
